/**
 * The red asterisk on a required field's label.
 *
 * Twelve places across five slices rendered this by hand as
 * `<span className="news-modal__required" aria-hidden="true">*</span>`. The class name was the
 * problem: a date picker and an organisation registration form both carried a class announcing
 * they were part of the news modal. It is now `required-mark`, which is what it is.
 *
 * ONE THING THIS COMPONENT DELIBERATELY DOES NOT FIX. `aria-hidden` on the asterisk is correct
 * only when the field itself tells assistive technology it is required — a `required` attribute
 * on the input, or `aria-required`. That holds in some callers and not others:
 * RegisterOrganizationPage marks two fields with an asterisk while neither its inputs nor its
 * labels carry `required` or `aria-required`, so a screen-reader user is told nothing at all.
 * Adding the attribute would change form validation, which is a behaviour change and not this
 * component's call to make — so the mark is preserved exactly as it renders today and the gap is
 * recorded here instead of being closed silently or, worse, hidden by the move.
 */
export function RequiredMark() {
  return (
    <span className="required-mark" aria-hidden="true">
      *
    </span>
  );
}
